import { NgClass } from '@angular/common';
import { Component } from '@angular/core';

import { LoadingSpinnerService } from '@services/loading-spinner/loading-spinner.service';

@Component({
  selector: 'loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
  imports: [NgClass],
})
export class LoadingSpinnerComponent {
  loading: boolean | undefined;

  constructor(private loaderService: LoadingSpinnerService) {
    this.loaderService.isLoading.subscribe(v => {
      this.loading = v;
    });
  }
}
